(function () {
    'use strict';

    angular
        .module('wsl.core')
        .factory('httpService', httpService);

    httpService.$inject = ['environmentService'];

    /* @ngInject */
    function httpService(environmentService) {
        var service = {
            prepareHttpParameters: prepareHttpParameters
        };

        return service;

        ////////////////

        function prepareHttpParameters(url, method, data, timeout) {
            if (typeof(url) == 'undefined' || url == null) {

            }
            if (url.indexOf('http:') == 0 && window.location.protocol === 'https:') {
                url = url.replace('http', 'https');
            }
            var browser = environmentService.getBrowser();
            if ((browser.name === 'msie' && browser.version.substr(0, 1) <= 9) ||
                (browser.name === 'opera' && browser.version.substr(0, 2) <= 11)) {
                method = 'JSONP';
                url += '?callback=JSON_CALLBACK';
            }
            var httpParams = {
                url: url,
                method: method
                //headers: {'Content-Type': 'application/x-www-form-urlencoded;'} //charset=UTF-8
            };
            if (method == 'GET') {
                httpParams.params = data;
            } else {
                //   httpParams.transformRequest = transformRequestAsFormPost;
                httpParams.data = data;
            }
            if (typeof(timeout) != 'undefined' && timeout != null) {
                httpParams.timeout = timeout;
            }
            return httpParams;
        }
    }
})();
